import TypeSelection, { TypeSelectionProps } from '../components/eligibility/TypeSelection';
import GeneralCheck, { GeneralEligibilityProps } from '../../../form/components/GeneralCheck';
import Citizenship, { CitizenshipProps } from '../../../form/components/Citizenship';
import Relationship, { RelationshipsInCanadaProps } from '../../../form/components/Relationship';
import EducationInput, { EducationInputProps } from '../../../form/components/EducationInput';
import LanguageInput, { LanguageInputProps } from '../../../form/components/LanguageInput';
import JobOffer, { JobOfferProps } from '../../../form/components/jobOffer';
import Employment, { EmploymentProps } from '../../../form/components/employment';
import NetWorth, { NetWorthProps } from '../../../form/components/NetWorth';
import Age, { AgeProps } from '../../../form/components/Age';
import ImmigrateCheck, { ImmigrateCheckProps } from '../../../form/components/SpecificTypes/ImmigrateCheck';
import VisitCheck, { VisitCheckProps } from '../../../form/components/SpecificTypes/VisitCheck';
import StudyCheck, { StudyCheckProps } from '../../../form/components/SpecificTypes/StudyCheck';
import WorkCheck, { WorkCheckProps } from '../../../form/components/SpecificTypes/WorkCheck';
import LeadInfoForm, { LeadInfoFormProps } from '../components/eligibility/LeadInfoForm';
import CompanyOwnership from '../../../form/components/CompanyOwnership';
import Visit from '../../../form/views/workflows/Visit';
import Study from '../../../form/views/workflows/Study';
import Work from '../../../form/views/workflows/Work';
import Immigrate from '../../../form/views/workflows/Immigrate';

interface WorkFlowProps
  extends Omit<
    TypeSelectionProps &
      GeneralEligibilityProps &
      CitizenshipProps &
      RelationshipsInCanadaProps &
      Omit<LanguageInputProps & JobOfferProps & EmploymentProps, 'importedSubmissionType'> &
      EducationInputProps &
      Omit<NetWorthProps, 'hideInvestable'> &
      AgeProps &
      ImmigrateCheckProps &
      VisitCheckProps &
      StudyCheckProps &
      WorkCheckProps &
      LeadInfoFormProps,
    'visible'
  > {
  isSuperVisas: boolean;
  currentQuestion: number;
}

function Workflow(props: WorkFlowProps) {
  const { currentQuestion, type, isSuperVisas } = props;
  if (isSuperVisas) {
    return (
      <>
        <TypeSelection visible={currentQuestion === 0} {...props} />
        <GeneralCheck visible={currentQuestion === 1} {...props} />
        <Citizenship visible={currentQuestion === 2} {...props} />
        <Relationship visible={currentQuestion === 3} {...props} />
        {
          {
            visitor: <Visit {...props} />,
            study: <Study {...props} />,
            work: <Work {...props} />,
            immigrate: <Immigrate {...props} />,
            all: <></>,
            sponsor_employee: <></>,
            sponsor_family: <></>,
            citizenship: <></>,
            additional_services: <></>,
            '': <></>,
          }[type]
        }
      </>
    );
  }
  return (
    <>
      <TypeSelection visible={currentQuestion === 0} {...props} />
      <GeneralCheck visible={currentQuestion === 1} {...props} />
      <Citizenship visible={currentQuestion === 2} {...props} />
      <Relationship visible={currentQuestion === 3} {...props} isExternal />
      <EducationInput visible={currentQuestion === 4} {...props} isExternal />
      <LanguageInput visible={currentQuestion === 5} {...props} importedSubmissionType={null} />
      <JobOffer visible={currentQuestion === 6} {...props} importedSubmissionType={null} />
      <Employment visible={currentQuestion === 7} {...props} importedSubmissionType={null} />
      <NetWorth visible={currentQuestion === 8} {...props} hideInvestable={false} />
      <Age visible={currentQuestion === 9} {...props} />
      <ImmigrateCheck visible={currentQuestion === 10} hideQuestionPNP {...props} />
      <VisitCheck visible={currentQuestion === 11} {...props} />
      <StudyCheck visible={currentQuestion === 12} {...props} />
      <WorkCheck visible={currentQuestion === 13} {...props} />
      <CompanyOwnership visible={currentQuestion === 14} {...props} />
      <LeadInfoForm visible={currentQuestion === 15} {...props} />
    </>
  );
}

export default Workflow;
